/**
 * Footer email-signup confirmation (QA round 04).
 *
 * The footer signup is placeholder markup pending the Gravity Forms / ESP
 * integration (see footer.twig): its action="#" meant submitting just
 * reloaded/scrolled the page with no feedback. Until the real endpoint is
 * wired, intercept the submit and swap the form for an inline success
 * message so visitors get a clear confirmation instead of a page refresh.
 *
 * NOTE: this only confirms the interaction — it does not yet store the
 * address. Replace this handler when the ESP endpoint lands.
 */
export default function initFooterSignup() {
	const form = document.querySelector('.site-footer__signup-form[data-signup-placeholder]');
	if (!form) {
		return;
	}

	form.addEventListener('submit', (e) => {
		e.preventDefault();

		// Let the browser's native required-field validation run first.
		if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
			return;
		}

		const message = document.createElement('div');
		message.className = 'site-footer__signup-success';
		message.setAttribute('role', 'status');
		message.setAttribute('tabindex', '-1');
		message.innerHTML =
			'<p class="site-footer__signup-success-heading">Thanks for signing up!</p>' +
			'<p class="site-footer__signup-success-text">Look out for job tips, updates, and new guides in your inbox.</p>';

		form.replaceWith(message);
		// Move focus to the confirmation so it's announced and keyboard users
		// aren't left on a control that no longer exists.
		message.focus();
	});
}
